import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const ticketsApi = api
  .enhanceEndpoints({
    addTagTypes: ["assigned"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getAllAssigned: builder.query<any, { branch_id: number | string }>({
        query: ({ branch_id }) => ({
          url: `recovery/get-all-active-users?branch_id=${branch_id}`,
          method: RequestMethod.GET,
        }),
      }),

      getPersonalBranchByUser: builder.query({
        query: ({ userId }) => ({
          url: ` assigned/personal-by-user/${userId}`,
          method: RequestMethod.GET,
        }),
      }),

      getSupportAssigned: builder.query<any, { branch_id: number | string }>({
        query: () => ({
          url: `assigned/support-staff`,
          method: RequestMethod.GET,
        }),
      }),
    }),
  });

export const {
  useGetAllAssignedQuery,
  useGetSupportAssignedQuery,
  useGetPersonalBranchByUserQuery,
} = ticketsApi;
